"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBackBox = exports.StyledNextGalleryBox = exports.StyledDescriptionBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var StyledDescriptionBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledDescriptionBox",
  componentId: "sc-4cpqqq-0"
})(["position:relative;max-width:312px !important;flex:0 0 auto;display:flex !important;height:", ";margin-right:80px;svg{path{fill:", ";}}"], function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return props.theme.portfolioForeground1;
});
exports.StyledDescriptionBox = StyledDescriptionBox;
var StyledNextGalleryBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledNextGalleryBox",
  componentId: "sc-4cpqqq-1"
})(["position:relative;height:", ";width:155px;margin-left:32px;svg{path{fill:", ";}}&:hover{p{color:", ";}svg{path{fill:", ";}}}"], function (props) {
  return "".concat(props.height, "px");
}, function (props) {
  return props.theme.portfolioForeground1;
}, function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme[props.colour];
});
exports.StyledNextGalleryBox = StyledNextGalleryBox;
var StyledBackBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__StyledBackBox",
  componentId: "sc-4cpqqq-2"
})(["&:hover{p{color:", ";}svg{path{fill:", ";}}}"], function (props) {
  return props.theme[props.colour];
}, function (props) {
  return props.theme[props.colour];
});
exports.StyledBackBox = StyledBackBox;